exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mt-10[data-v-5831dbd4] {\n  margin-top: 10px;\n}\n", ""]);

// exports
